import { mountRaceList } from './utils/mount-race-list.js';
import { LA_CITY_URL } from './constants.js';
import { SHARED_RACES } from './shared-races.js';

// first parameter here needs to match what's in the multipleRaces js file
mountRaceList('la-city-council-results', LA_CITY_URL, {
  // filter options: FilterSpec in stores.js
  filter: [
    {
      ids: [
        'los-angeles-city-general-municipal-election-member-of-the-city-council-3rd-district-4348',
        'los-angeles-city-general-municipal-election-member-of-the-city-council-9th-district-4348',
      ],
      sort: 'title',
    },
  ],
  component: 'result', // to show 2 col table
  sharedRaces: SHARED_RACES,
}).catch(console.error);
